import Vue from 'vue'
import Router from 'vue-router'



// 导入刚才编写的组件

import Login from '@/components/home/Login.vue'
import Header from '@/components/home/Header.vue'
import HelloWorld from '@/components/home/HelloWorld.vue'

import AdvertisingPyramid from "@/components/gameData/抖音/AdvertisingPyramid.vue";
import ToufangBroad from "@/components/gameData/抖音/ToufangBroad.vue";
import GameBroad from "@/components/gameData/抖音/GameBroad.vue";
import ProjectBroad from "@/components/gameData/抖音/ProjectBroad.vue";
import JuliangWaring from "@/components/gameData/抖音/JuliangWaring.vue";
import WxWaring from "@/components/gameData/微信/WxWaring.vue";
import CompanyConfig from "@/components/gameData/抖音/CompanyConfig.vue";
import ToufangWxBroad from "@/components/gameData/微信/ToufangWxBroad.vue";
import Test from "@/components/gameData/抖音/Test.vue";
import GameWxBroad from "@/components/gameData/微信/GameWxBroad.vue";
import GameWxBroad2 from "@/components/gameData/微信/GameWxBroad2.vue";
import Game2 from "@/components/gameData/抖音/Game2.vue";
import Game3 from "@/components/gameData/抖音/Game3.vue";
import Error from "@/components/home/Error.vue";
import Game4 from "@/components/gameData/抖音/Game4.vue";
import GameWx3 from "@/components/gameData/微信/GameWx3.vue";

import GameWx3V1 from "@/components/gameData/微信/GameWx3V1.vue";
import GameWx4 from "@/components/gameData/微信/GameWx4.vue";
import GameConfig from "@/components/gameData/微信/GameConfig.vue";
import GameConfigWx from "@/components/gameData/抖音/GameConfigWx.vue";
import VideoBroad from "@/components/gameData/微信/VideoBroad.vue";
import GameConfigSp from "@/components/gameData/微信/GameConfigSp.vue";
import ToufangPersonalBoard from "@/components/gameData/抖音/ToufangPersonalBoard.vue";
import pluginRedirect from "@/components/gameData/MP/pluginRedirect.vue";
import ToufangSelf2 from "@/components/gameData/抖音/ToufangSelf2.vue";
import TouFang from "@/components/gameData/微信/TouFang.vue";
import GameWx3New from "@/components/gameData/微信/GameWx3New.vue";
import ToufangSelfWx from "@/components/gameData/微信/ToufangSelfWx.vue";
import WxHourData from "@/components/gameData/微信/WxHourData.vue";
import PermissionManagement from "@/components/home/PermissionManagement.vue";
import dataChart from "@/components/gameData/微信/dataChart.vue";
import oneClickConfig from "@/components/gameData/微信/OneClickConfig.vue";
import oneClickConfig2 from "@/components/gameData/微信/OneClickConfig2.vue";
import HelloWorld2 from "@/components/home/HelloWorld2.vue";
import gameLogin from "@/components/gameData/微信/GameLogin.vue";
import MpData from "@/components/gameData/微信/MpData.vue";

import campaignsIndex from "@/components/index.vue";
import adsIndex from "@/components/views/ads/adsIndex.vue";
import adgroupsIndex from "@/components/views/adgroups/adgroupsIndex.vue";

import allCampaignPage from "@/components/views/AllCampaignsPage.vue"
import VideoLibrary from "@/components/views/video/VideoLibrary.vue";
import AigcVideoGenerator from "@/components/views/video/AigcVideoGenerator.vue";
import AigcImageGenerator from "@/components/views/video/AigcImageGenerator.vue";
import AigcQuotaGroupPage from "@/components/views/video/AigcQuotaGroupPage.vue";
import AigcProviderConfigPage from "@/components/views/video/AigcProviderConfigPage.vue";
import VideoStorageConfigPage from "@/components/views/video/VideoStorageConfigPage.vue";
import adsIndexV2 from "@/components/views/ads/adsIndexV2.vue";
import GameWx3V2 from "@/components/gameData/微信/GameWx3V2.vue";
import MpDataDub from "@/components/gameData/微信/MpDataDub.vue";
import HourlyRevenueMonitor from "@/components/views/ads/HourlyRevenueMonitor.vue";
import RevenueAnalysis from "@/components/views/ads/RevenueAnalysis.vue";
import OceanEngineAccountDirectory from "@/components/views/OceanEngineAccountDirectory.vue";


Vue.use(Router)


export default new Router({
    base: '/',
    // mode: 'hash',
    routes: [
        // 下面都是固定的写法
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                keepAlive: false
            }
        },

        {
            path: '/header',
            name: 'Header',
            component: Header,
            meta: {
                keepAlive: false,
                requireAuth: true
            }

        },


        {
            path: '/HelloWorld',
            name: 'HelloWorld',
            component: HelloWorld2,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title: '系统监控'
            }

        }, {
            path: '/ToufangBroad',
            name: 'ToufangBroad',
            component: ToufangBroad,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'抖音投放看板',
                searchPreset:{
                    "date":[],
                    "name":'',

                }
            }

        },  {
            path: '/GameBroad',
            name: 'GameBroad',
            component: GameBroad,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'产品回收梯形图'
            }

        },   {
            path: '/ProjectBroad',
            name: 'ProjectBroad',
            component: ProjectBroad,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'项目回收梯形图'
            }

        },{
            path: '/AdvertisingPyramid',
            name: 'AdvertisingPyramid',
            component: AdvertisingPyramid,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'广告回收梯形图'
            }

        },{
            path: '/JuliangWarning',
            name: 'JuliangWarning',
            component: JuliangWaring,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'巨量配置'
            }

        },{
            path: '/WxWarning',
            name: 'WxWarning',
            component: WxWaring,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'广点通配置'
            }

        },  {
            path: '/CompanyConfig',
            name: 'CompanyConfig',
            component: CompanyConfig,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'框返配置'
            }

        },{
            path: '/ToufangWxBroad',
            name: 'ToufangWxBroad',
            component: ToufangWxBroad,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信投放看板'
            }

        },{
            path: '/Test',
            name: 'Test',
            component: Test,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'修改预估倍率'
            }

        },{
            path: '/GameWxBroad',
            name: 'GameWxBroad',
            component: GameWxBroad,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信产品'
            }

        },{
            path: '/GameWxBroad2',
            name: 'GameWxBroad2',
            component: GameWxBroad2,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信产品回收梯形图'
            }

        },{
            path: '/Game2',
            name: 'Game2',
            component: Game2,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'创意维度明细'
            }

        },{
            path: '/Game3',
            name: 'Game3',
            component: () => import('@/components/views/OceanEngineCreativeDetail.vue'),
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'创意维度明细'
            }

        },{
            path: '/Error',
            name: 'Error',
            component: Error,
            meta: {
                keepAlive: true,
                requireAuth: false,
                title:'错误'
            }

        },{
            path: '/Game4',
            name: 'Game4',
            component: Game4,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'游戏维度汇总'
            }

        },{
            path: '/GameWx3',
            name: 'GameWx3',
            component: GameWx3New,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信游戏维度子表(总)'
            }

        },{
            path: '/GameWx3V1',
            name: 'GameWx3V1',
            component: GameWx3V1,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信游戏维度子表(新)'
            }

        },{
            path: '/GameWx3V2',
            name: 'GameWx3V2',
            component: GameWx3V2,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信广告维度(新)'
            }

        },{
            path: '/GameWx4',
            name: 'GameWx4',
            component: GameWx4,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信游戏维度'
            }

        },{
            path: '/GameConfig',
            name: 'GameConfig',
            component: GameConfig,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'抖音游戏分类'
            }

        },{
            path: '/GameConfigWx',
            name: 'GameConfigWx',
            component: GameConfigWx,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信游戏分类'
            }

        },{
            path: '/VideoBroad',
            name: 'VideoBroad',
            component: VideoBroad,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'视频号看板'
            }

        },{
            path: '/GameConfigSp',
            name: 'GameConfigSp',
            component: GameConfigSp,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'游戏配置'
            }

        },{
            path: '/ToufangSelf',
            name: 'ToufangSelf',
            component: ToufangPersonalBoard,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'个人看板'
            }

        },{
            path: '/pluginRedirect',
            name: 'pluginRedirect',
            component: pluginRedirect,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'外部渠道'
            }

        },{
            path: '/ToufangSelf2',
            name: 'ToufangSelf2',
            component: ToufangSelf2,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'个人看板创意'
            }

        },{
            path: '/TouFang',
            name: 'TouFang',
            component: TouFang,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信游戏投放'
            }

        }
        ,{
            path: '/ToufangSelfWx',
            name: 'ToufangSelfWx',
            component: ToufangSelfWx,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'个人微信看板创意'
            }

        } ,{
            path: '/WxHourData',
            name: 'WxHourData',
            component: WxHourData,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信时段看板'
            }

        } ,{
            path: '/PermissionManagement',
            name: 'PermissionManagement',
            component: PermissionManagement,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'权限分配'
            }

        } ,{
            path: '/dataChart',
            name: 'dataChart',
            component: dataChart,
            meta: {
                keepAlive: true,
                requireAuth: false,
                title:'图表'
            }

        },{
            path: '/oneClickConfig',
            name: 'oneClickConfig',
            component: oneClickConfig2,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'一键起量配置'
            }

        },{
            path: '/gameLogin',
            name: 'gameLogin',
            component: gameLogin,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信一键登录'
            }

        },{
            path: '/mpData',
            name: 'mpData',
            component: MpData,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信后台数据'
            }

        },{
            path: '/MpDataDub',
            name: 'MpDataDub',
            component: MpDataDub,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'微信工具箱数据'
            }

        },{
            path: '/campaignsIndex',
            name: 'campaignsIndex',
            component: campaignsIndex,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'广告系列管理'
            }

        },{
            path: '/adsIndex',
            name: 'adsIndex',
            component: adsIndex,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'广告管理'
            }

        },{
            path: '/batchsAdd',
            name: 'batchsAdd',
            component: adsIndexV2,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'批量创建',
                componentName: 'BatchAdCreator'
            }

        },{
            path: '/adgroupsIndex',
            name: 'adgroupsIndex',
            component: adgroupsIndex,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'广告组管理'
            }

        },{

        path: '/allCampaignPage',
        name: 'allCampaignPage',
        component: allCampaignPage,
        meta: {
            keepAlive: true,
            requireAuth: true,
            title:'所有广告系列'
        }
        },{

            path: '/VideoLibrary',
            name: 'VideoLibrary',
            component: VideoLibrary,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'视频库'
            }
        },{
            path: '/AigcVideoGenerator',
            name: 'AigcVideoGenerator',
            component: AigcVideoGenerator,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'AI视频生成'
            }
        },{
            path: '/AigcImageGenerator',
            name: 'AigcImageGenerator',
            component: AigcImageGenerator,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'AI图片生成'
            }
        },{
            path: '/AigcProviderConfig',
            name: 'AigcProviderConfig',
            component: AigcProviderConfigPage,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'AI服务商配置'
            }
        },{
            path: '/AigcQuotaGroups',
            name: 'AigcQuotaGroups',
            component: AigcQuotaGroupPage,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'AI分组额度'
            }
        },{
            path: '/VideoStorageConfig',
            name: 'VideoStorageConfig',
            component: VideoStorageConfigPage,
            meta: {
                keepAlive: true,
                requireAuth: true,
                title:'视频存储配置'
            }
        },
        {
            path: '/smart-plus-report',
            name: 'SmartPlusMaterialReport',
            component: () => import('@/components/gameData/tiktok/SmartPlusMaterialReport.vue'),
            meta: { title: 'Smart+ 素材报表' ,keepAlive: true, requireAuth: true}
        },{
            path: '/tiktok/campaign-report',
            name: 'CampaignReport',
            component: () => import('@/components/gameData/tiktok/CampaignReport.vue'),
            meta: {
                title: 'TikTok 推广系列报表'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/tiktok/advertiser-report',
            name: 'AdvertiserReport',
            component: () => import('@/components/gameData/tiktok/AdvertiserReport.vue'),
            meta: {
                title: 'TikTok 广告主报表'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/tiktok/ad-create-logs',
            name: 'AdCreateLog',
            component: () => import('@/components/gameData/tiktok/AdCreateLog.vue'),
            meta: {
                title: 'TikTok 批量创建日志'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/tiktok/developer-iaa-data',
            name: 'DeveloperIaaData',
            component: () => import('@/components/gameData/tiktok/DeveloperIaaData.vue'),
            meta: {
                title: 'TikTok Developer IAA数据'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/tiktok/campaign-rule',
            name: 'CampaignRuleManager',
            component: () => import('@/components/gameData/tiktok/CampaignRuleManager.vue'),
            meta: {
                title: 'TikTok 自动化规则管理' ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/hourly-revenue-monitor',
            name: 'HourlyRevenueMonitor',
            component: HourlyRevenueMonitor,
            meta: {
                title: '小时回收监控'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/revenue-analysis',
            name: 'RevenueAnalysis',
            component: RevenueAnalysis,
            meta: {
                title: '数据分析'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/ToufangGamePermission',
            name: 'ToufangGamePermission',
            component: () => import('@/components/views/ToufangGamePermission.vue'),
            meta: {
                title: '用户游戏权限'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/ToufangY4HistoryMatrix',
            name: 'ToufangY4HistoryMatrix',
            component: () => import('@/components/views/ToufangY4HistoryMatrix.vue'),
            meta: {
                title: 'Y4授权历史数据'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/MpTencentPrediction',
            name: 'MpTencentPrediction',
            component: () => import('@/components/views/MpTencentPrediction.vue'),
            meta: {
                title: '腾讯预估倍率'
                ,keepAlive: true, requireAuth: true, outId: '33'
            }
        },{
            path: '/TencentAiData',
            name: 'TencentAiData',
            component: () => import('@/components/views/TencentAiData.vue'),
            meta: {
                title: '腾讯广告AI数据'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/TencentAiRoiRules',
            name: 'TencentAiRoiRules',
            component: () => import('@/components/views/TencentAiRoiRules.vue'),
            meta: {
                title: '腾讯广告ROI自动规则'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/OceanEngineAccountDirectory',
            name: 'OceanEngineAccountDirectory',
            component: OceanEngineAccountDirectory,
            meta: {
                title: '巨量账号目录'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/OceanEngineOperationLogs',
            name: 'OceanEngineOperationLogs',
            component: () => import('@/components/views/OceanEngineOperationLogs.vue'),
            meta: {
                title: '巨量操作日志'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/OceanEngineAiData',
            name: 'OceanEngineAiData',
            component: () => import('@/components/views/OceanEngineAiData.vue'),
            meta: {
                title: '巨量广告AI数据'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/ProjectSummaryHistory',
            name: 'ProjectSummaryHistory',
            component: () => import('@/components/views/ProjectSummaryHistory.vue'),
            meta: {
                title: '项目汇总'
                ,keepAlive: true, requireAuth: true
            }
        },{
            path: '/VideoBoostOrders',
            name: 'VideoBoostOrders',
            component: () => import('@/components/views/VideoBoostOrders.vue'),
            meta: {
                title: '加热订单看板',
                keepAlive: true,
                requireAuth: true
            }
        },{
            path: '/VideoBoostAccountStats',
            name: 'VideoBoostAccountStats',
            component: () => import('@/components/views/VideoBoostAccountStats.vue'),
            meta: {
                title: '视频号加热账号看板',
                keepAlive: true,
                requireAuth: true
            }
        },{
            path: '/VideoBoostGameStats',
            name: 'VideoBoostGameStats',
            component: () => import('@/components/views/VideoBoostGameStats.vue'),
            meta: {
                title: '视频号加热游戏看板',
                keepAlive: true,
                requireAuth: true
            }
        },{
            path: '/VideoBoostAutoOrder',
            name: 'VideoBoostAutoOrder',
            component: () => import('@/components/views/VideoBoostAutoOrder.vue'),
            meta: {
                title: '加热下单配置',
                keepAlive: true,
                requireAuth: true
            }
        },{
            path: '/MpVideoPrediction',
            name: 'MpVideoPrediction',
            component: () => import('@/components/views/MpTencentPrediction.vue'),
            meta: {
                title: '视频号预估倍率'
                ,keepAlive: true, requireAuth: true, outId: '62'
            }
        }
    ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
